var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50948 16.1354C1.75169 18.3993 3.57251 20.2201 5.83529 20.4723C7.51601 20.6597 9.24169 20.8206 11.0011 20.8206C12.7605 20.8206 14.4862 20.6597 16.1669 20.4723C18.4297 20.2201 20.2505 18.3993 20.4928 16.1354C20.6716 14.4642 20.8225 12.7484 20.8225 10.9992C20.8225 9.24992 20.6716 7.53413 20.4928 5.8629C20.2505 3.59903 18.4297 1.7782 16.1669 1.52598C14.4862 1.33864 12.7605 1.17773 11.0011 1.17773C9.24169 1.17773 7.51601 1.33864 5.83529 1.52598C3.57251 1.7782 1.75169 3.59903 1.50948 5.8629C1.33068 7.53413 1.17969 9.24992 1.17969 10.9992C1.17969 12.7484 1.33068 14.4642 1.50948 16.1354Z",
    fill: "#426306"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50948 16.1354C1.75169 18.3993 3.57251 20.2201 5.83529 20.4723C7.51601 20.6597 9.24169 20.8206 11.0011 20.8206C12.7605 20.8206 14.4862 20.6597 16.1669 20.4723C18.4297 20.2201 20.2505 18.3993 20.4928 16.1354C20.6716 14.4642 20.8225 12.7484 20.8225 10.9992C20.8225 9.24992 20.6716 7.53413 20.4928 5.8629C20.2505 3.59903 18.4297 1.7782 16.1669 1.52598C14.4862 1.33864 12.7605 1.17773 11.0011 1.17773C9.24169 1.17773 7.51601 1.33864 5.83529 1.52598C3.57251 1.7782 1.75169 3.59903 1.50948 5.8629C1.33068 7.53413 1.17969 9.24992 1.17969 10.9992C1.17969 12.7484 1.33068 14.4642 1.50948 16.1354Z",
    stroke: "#84C70D",
    strokeWidth: 2.35714
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 10.2148C15.2688 10.2148 16.5 8.98363 16.5 7.46484C16.5 5.94606 15.2688 4.71484 13.75 4.71484C12.2312 4.71484 11 5.94606 11 7.46484C11 8.98363 12.2312 10.2148 13.75 10.2148Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8333 20.4736C3.57052 20.2214 1.7497 18.4006 1.50749 16.1367C1.36057 14.7635 1.23244 13.3602 1.19141 11.933C1.8313 11.8336 2.47824 11.7844 3.12626 11.7862C5.86765 11.7242 8.5419 12.6382 10.6718 14.3652C12.6472 15.9669 14.0352 18.1711 14.6299 20.6325C13.4386 20.7435 12.2271 20.8219 10.9991 20.8219C9.2397 20.8219 7.51402 20.661 5.8333 20.4736Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.631 20.6312C15.1465 20.5831 15.6583 20.5289 16.166 20.4723C18.4288 20.2201 20.2496 18.3993 20.4918 16.1354C20.5187 15.8841 20.5449 15.6317 20.5702 15.3784C19.4968 15.079 18.3865 14.9271 17.2701 14.9278C15.5792 14.9241 13.9054 15.2663 12.3516 15.9335L12.3516 16.0377C13.4408 17.3732 14.2228 18.9416 14.631 20.6312Z",
    fill: "#426306",
    stroke: "#84C70D",
    strokeWidth: 2.35714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.1aa704eaf7f7e56f897d513a5ff064db.svg";
export { ForwardRef as ReactComponent };